exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 1150px) {\n  .tipoEmbarque {\n    background-color: #F2F2F2 !important;\n    border-radius: 0 0 8px 8px;\n    margin-top: 0px !important;\n    margin-left: -16px !important; } }\n", ""]);

